<template>


    <div class="page-content">   
		<div data-height="150" class="page-title-bg bg-20"><!-- image --></div>
		<div data-height="150" class="page-title-bg dark-mode-tint"><!-- contrast for dark mode --></div>
		<div data-height="150" class="page-title-bg opacity-90 bg-highlight"><!-- background color --></div>
		
		<div class="page-title-small color-white bottom-30">
			<h1><i class="fa fa-arrow-left back-button"></i>Ingreso datos Nueva OT</h1>
			<a href="/dashboard" data-menu="menu-main" class="shadow-huge scale-box bg-fade-gray2-dark" v-bind:style="userimageurl"></a>
		</div>
	
     
		<div class="content-boxed">


  			<div class="content bottom-0">
				
 			<div class="calendar">
				<div class="search-box search-color bg-magenta1-dark shadow-tiny round-huge bottom-0">
					<i class="fa fa-search"></i>
					<input type="text" v-model="datasearchporpatente" @keyup="datasearchfxvehiculo" @input="buscarTodosLosClientes" placeholder="Buscar vehículo por patente" data-search maxlength="6" style="text-transform: uppercase">
					<a href="#" class="button bg-blue1-dark button-m button-full round bottom-10 shadow-small contactSubmitButton" @click="crearvehiculo" data-formId="dataForm">Nuevo</a>
				</div>
			</div>


 


               <div class="contact-form">
                    <form onsubmit="event.preventDefault();" class="contactForm" id="Formsubmit">

						<div data-height="200" class="caption caption-margins round-medium shadow-large">
							<div class="caption-bottom left-20 bottom-15">
								<p class="bottom-0 color-white opacity-50 under-heading font-12">{{ sucursal }}</p>
								<h1 class="color-white bottom-0 bolder">N° Ficha {{ OT.codvehiculo }}</h1>
								<h1 class="color-white bottom-0 bolder">{{ OT.marca }}</h1>
								<h1 class="color-white bottom-0 bolder">{{ OT.modelo }}</h1>
								<h1 class="color-white bottom-0 bolder">{{ OT.agno }}</h1>
								<p class="bottom-0 color-white opacity-50 under-heading font-12">{{ OT.vin }}</p>
								<h1 class="color-white bottom-0 bolder">{{ OT.placapatente }}</h1>
							</div>
							<div class="caption-overlay bg-black opacity-75"></div>
							<div class="caption-bg bg-29"></div>
						</div>   

						<div class="calendar">
							<div class="search-box search-color bg-magenta1-dark shadow-tiny round-huge bottom-0">
								<i class="fa fa-search"></i>
								<input id="InputCliente" type="text" v-model="datasearchporrut" @keyup="datasearchfxcliente(datasearchporrut)" placeholder="Buscar cliente por rut" data-search maxlength="9" style="text-transform: uppercase">
								<a	href="#" class="button bg-green2-dark button-m button-full round bottom-10 shadow-small contactSubmitButton" @click="crearcliente" data-formId="dataForm">Nuevo</a>
							</div>
						</div>
						<div v-if="tipoCliente == 3" data-height="150" class="caption caption-margins round-medium shadow-large">
							<div class="caption-bottom left-20 bottom-15">
								<h2 class="color-white bottom-0 bolder">{{ Cliente.nombre }}</h2>
								<br>
								<p class="bottom-0 color-white under-heading font-12">{{ Cliente.fono1 }}</p>
							</div>
							<div class="caption-overlay bg-black opacity-75"></div>
							<div class="caption-bg bg-27"></div>
						</div>
						<div v-else data-height="150" class="caption caption-margins round-medium shadow-large">
							<div class="caption-bottom left-20 bottom-15">
								<h2 class="color-white bottom-0 bolder">{{ Cliente.nombre }}</h2>
								<h2 class="color-white bottom-0 bolder">{{ Cliente.paterno }}</h2>
								<h2 class="color-white bottom-0 bolder">{{ Cliente.materno }}</h2>
								<br>
								<p class="bottom-0 color-white under-heading font-12">{{ Cliente.fono1 }}</p>
							</div>
							<div class="caption-overlay bg-black opacity-75"></div>
							<div class="caption-bg bg-27"></div>
						</div>
						
						<div class="calendar" id="divClientes" style="display: none;">
							<div style="width: 100%;" class="search-box search-color bg-magenta1-dark shadow-tiny round-huge bottom-0">
								<select class="form-select form-select-lg mb-3 bg-magenta1-dark" id="Clientes" style="width: 95%;" @change="clienteSeleccionado">
								</select>
							</div>
						</div>


						<div v-if="!blnCreaVehiculo" class="content-boxed">
								<a href="#" class="button bg-blue2-dark button-m button-full round-small bottom-10 shadow-small contactSubmitButton" @click="siguiente" data-formId="dataForm">Crear Orden de trabajo</a>
						</div>

                    </form>			
                </div>
            </div>

 


    	</div>
		
    </div>


</template>

<script>

import * as db from "../../database.js";
import * as validate from "../../validate.js";

export default {
	data() {
      return {
		codsucursal:JSON.parse(localStorage.getItem('user')).codsucursal,
		sucursal:JSON.parse(localStorage.getItem('user')).sucursal,
		tipoCliente: 0,

		Direccioncliente:{},
		OT:{
			codvehiculo:0,
			placapatente:"",
			agno:0,
			codmarca:0,
			codmodelo:0,
			marca:"",
			modelo:"",
			vin:""
		},

		Cliente:{
			codcliente:0,
			nombre:"",
			paterno:"",
			materno:"",
			fono1:"",
			},


		}
	},

	mounted() {
		if(localStorage.getItem('searchplacapatente')!=null && localStorage.getItem('searchplacapatente')!="")
			{
			this.datasearchporpatente=localStorage.getItem('searchplacapatente');
			this.datasearchfxvehiculo();
			}

		if(localStorage.getItem('searchcliente')!=null && localStorage.getItem('searchcliente')!="")
			{
			this.datasearchporrut=localStorage.getItem('searchcliente');
			let rut = localStorage.getItem('searchcliente');
			this.datasearchfxcliente(rut);
			}

	},


	methods: {

	// Reintenta automáticamente cuando el backend falla por el error intermitente
	// de TLS/SSL ("No se puede crear un canal seguro SSL/TLS"). Otros errores pasan igual.
	esErrorSSL(err){
		return !!err && /canal seguro|SSL|TLS/i.test(err);
	},

	llamarConReintento(metodo, fx, params, intentos){
		var self = this;
		if (intentos === undefined) intentos = 4; // 5 intentos en total
		var espera = (5 - intentos) * 400; // 400, 800, 1200, 1600 ms (creciente)
		return db[metodo](fx, params).then(function(result){
			var err = result && result.data ? result.data.err : "";
			if (self.esErrorSSL(err) && intentos > 0){
				console.log("⚠️ " + fx + " falló por SSL/TLS. Reintentando en " + espera + "ms (quedan " + intentos + ")");
				return new Promise(function(r){ setTimeout(r, espera); })
					.then(function(){ return self.llamarConReintento(metodo, fx, params, intentos - 1); });
			}
			if (self.esErrorSSL(err)){
				console.log("❌ " + fx + " siguió fallando por SSL/TLS tras todos los reintentos.");
			}
			return result;
		}).catch(function(e){
			if (intentos > 0){
				return new Promise(function(r){ setTimeout(r, espera); })
					.then(function(){ return self.llamarConReintento(metodo, fx, params, intentos - 1); });
			}
			throw e;
		});
	},

	datasearchfxvehiculo()
	{
		if(this.datasearchporpatente=="" || this.datasearchporpatente.length<6) return;

		// Buscar la patente DIRECTO en la BD de NetCar (T_VEH_VEHICULO), sin pasar por
		// el servicio externo de BCI Seguros (que es el que daba el error SSL/TLS).
		var pat = this.datasearchporpatente.toUpperCase().replace(/'/g, "");
		var sql = "SELECT TOP 1 V.IN_COD_VEHICULO codvehiculo, V.ST_PLACAPATENTE_VEHICULO placapatente,"
			+ " V.IN_AGNOFABRICACION_VEHICULO agno, V.IN_VALORNIVEL1_VEHICULO codmarca, V.IN_VALORNIVEL2_VEHICULO codmodelo,"
			+ " (SELECT ST_DESC_DETALLECLASIFICACION FROM T_GEN_DETALLECLASIFICACION WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL1_VEHICULO) marca,"
			+ " (SELECT ST_DESC_DETALLECLASIFICACION FROM T_GEN_DETALLECLASIFICACION WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL2_VEHICULO) modelo,"
			+ " ISNULL(V.ST_NVIN_VEHICULO,'') vin"
			+ " FROM T_VEH_VEHICULO V WHERE V.ST_PLACAPATENTE_VEHICULO='" + pat + "' ORDER BY V.IN_COD_VEHICULO DESC";

		db.getQuery(sql).then(result => {
			var data = result.data.data;
			var v = Array.isArray(data) ? (data.length ? data[0] : null) : (data || null);
			if (result.data.err != "" || !v || !v.codvehiculo)
			{
				// No existe en NetCar -> ofrecer crearlo
				this.OT = { codvehiculo:0, placapatente:pat, agno:0, codmarca:0, codmodelo:0, marca:"", modelo:"", vin:"" };
				localStorage.setItem('searchplacapatente', pat);
				console.log("Patente no encontrada en NetCar (vehículo nuevo): " + pat);
				// Preguntar una sola vez por cada patente distinta
				if (this._patentePrompt !== pat) {
					this._patentePrompt = pat;
					if (confirm("No existe la patente " + pat + ". ¿Desea crearla?")) {
						this.crearvehiculo();
					}
				}
			}
			else
			{
				this._patentePrompt = null;
				this.OT = {
					codvehiculo: v.codvehiculo,
					placapatente: v.placapatente,
					agno: v.agno,
					codmarca: v.codmarca,
					codmodelo: v.codmodelo,
					marca: v.marca,
					modelo: v.modelo,
					vin: v.vin
				};
				localStorage.setItem('searchplacapatente', v.placapatente);
			}
		});
	},

	datasearchfxcliente(rut)
	{
		var rutDigits = (rut || "").toString().toUpperCase().replace(/[^0-9K]/g, "");
		if (rutDigits.length < 8) return;

		// Buscar el cliente DIRECTO en T_CLI_CLIENTE por RUT (ignora puntos/guión y tolera con o sin dígito verificador)
		var sql = "SELECT TOP 1 IN_COD_CLIENTE codcliente, ST_RUT_CLIENTE rut,"
			+ " ISNULL(ST_NOMBRE_CLIENTE,'') nombre, ISNULL(ST_APEPAT_CLIENTE,'') paterno,"
			+ " ISNULL(ST_APEMAT_CLIENTE,'') materno, ISNULL(ST_FONO1_CLIENTE,'') fono1"
			+ " FROM T_CLI_CLIENTE"
			+ " WHERE REPLACE(REPLACE(REPLACE(ST_RUT_CLIENTE,'.',''),'-',''),' ','') LIKE '" + rutDigits + "%'"
			+ " OR '" + rutDigits + "' LIKE REPLACE(REPLACE(REPLACE(ST_RUT_CLIENTE,'.',''),'-',''),' ','') + '%'"
			+ " ORDER BY IN_COD_CLIENTE DESC";

		db.getQuery(sql).then(result => {
			var data = result.data.data;
			var cli = Array.isArray(data) ? (data.length ? data[0] : null) : (data || null);
			if (cli && cli.codcliente)
			{
				// Cliente encontrado
				if (this._rutTimer) clearTimeout(this._rutTimer);
				this._rutPrompt = null;
				this.Cliente = cli;
				db.getFx2("ot.buscartipocliente", '{"datasearch":"' + this.Cliente.codcliente +'"}').then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
					this.tipoCliente = result.data.data;
				}});
			}
			else
			{
				// Cliente no existe -> al terminar de escribir, ofrecer crearlo (una vez por RUT)
				if (this._rutTimer) clearTimeout(this._rutTimer);
				var self = this;
				var rutActual = rut;
				this._rutTimer = setTimeout(function(){
					if (self.datasearchporrut === rutActual && self._rutPrompt !== rutActual) {
						self._rutPrompt = rutActual;
						if (confirm("El cliente no existe. ¿Quiere crear un cliente nuevo?")) {
							self.crearcliente();
						}
					}
				}, 900);
			}
		});
	},

	buscarTodosLosClientes()
	{
		let codsucursal=JSON.parse(localStorage.getItem('user')).codsucursal;
		if(this.datasearchporpatente!="" && this.datasearchporpatente.length>=6)
			this.llamarConReintento("getFx2","ot.buscarclienteporpatente",'{"datasearch":"'+this.datasearchporpatente+'","codsucursal":"'+codsucursal+'"}')   .then(result => {if (result.data.err!="")
			{
				// alert(result.data.err);
				// console.log (result.data.err);

				document.getElementById("divClientes").style.display = "none";
			}
			else
			{
				let clientes = result.data.data;

				let selectClientes = document.getElementById('Clientes');

				selectClientes.innerHTML = '';

                let optionPlaceholder = document.createElement('option');
                optionPlaceholder.disabled = true;
                optionPlaceholder.selected = true;
                optionPlaceholder.hidden = true;
                optionPlaceholder.textContent = 'SELECCIONE UN CLIENTE';
                selectClientes.appendChild(optionPlaceholder);

				document.getElementById("divClientes").style.display = "flex";

				clientes.forEach(cliente => {
					// Crea un elemento option
					let option = document.createElement('option');
					
					// Asigna el valor y texto al option
					option.value = cliente.rut + cliente.dv; 
					option.textContent = cliente.nombre; 
					
					// Agrega el option al select
					selectClientes.appendChild(option);
				});
			}
		});
	},

	clienteSeleccionado(event) {
        // Obtén el valor del cliente seleccionado
        let valorCliente = event.target.value;
                
        // Asignar el valor del cliente seleccionado al input
		document.getElementById('InputCliente').value = valorCliente;

		// Disparar el evento keyup para ejecutar la búsqueda del cliente
		document.getElementById('InputCliente').dispatchEvent(new Event('keyup'));

		this.datasearchporrut=valorCliente;

		this.datasearchfxcliente(valorCliente);
    },

	crearvehiculo()
	  {
		localStorage.setItem('editcodvehiculo',"");

		window.location="/Newvehiculo";
          //this.$router.push('/ClientNew/'+OT.placapatente);
	  },
	crearcliente()
	  {		  
		localStorage.setItem('editcodcliente',"");
		window.location="/Newcliente";
          //this.$router.push('/ClientNew/'+OT.placapatente);
	  },


		siguiente() {
			let codusuario = JSON.parse(localStorage.getItem('user')).codusuario;

			db.getFx("ot.crearOT", '{"codcliente":"' + this.Cliente.codcliente + '","codvehiculo":"' + this.OT.codvehiculo + '","codasesor":"' + codusuario + '"}').then(result => {
				if (result.data.err != "") { alert(result.data.err); console.log(result.data.err); console.log("Error") } else {

					localStorage.setItem('searchplacapatente', "");
					localStorage.setItem('searchcliente', "");

					localStorage.setItem('idcotizacionvehiculo', result.data.data.idcotizacionvehiculo)
					localStorage.setItem('idagenda', result.data.data.idagenda)
					localStorage.setItem('fechaagenda', result.data.data.fechaagenda)
					localStorage.setItem('horaagenda', result.data.data.hora)

					window.location = "/Wizardot2data"
				}
			});
			//Ingresar OT
		}

	}
}

</script>

<style>
	select#Clientes option:hover {
		background-color: #8D7FB1; /* Cambia "tu-color-aqui" por el color deseado */
	}
</style>
